import { ERROR_CLASSNAME_INPUT } from '../constants';

export const getFirstValidationErrorMessage = (errors) => {
  const messages = getValidationErrorMessages(errors);
  if (!(messages && messages.length)) {
    return undefined;
  }

  return messages[0];
};

export const getValidationErrorMessages = (errors) => {
  if (!(errors && errors.length)) {
    return undefined;
  }

  const validationError = errors.find((e) => e.extensions && e.extensions.category === 'validation');
  if (!validationError) {
    return undefined;
  }

  const { validation } = validationError.extensions;
  const messages = Object.values(validation);
  if (!messages.length) {
    return undefined;
  }

  const res = [];
  messages.forEach((array) => {
    array.forEach((i) => res.push(i));
  });

  return res;
};

export const getValidationErrorMessagesRest = (data) => {
  if (!(data && data.errors)) {
    return undefined;
  }

  const messages = Object.values(data.errors);
  if (!messages.length) {
    return undefined;
  }

  return messages[0];
};

export const removeErrorStyle = (divId = 'app') => {
  const targetDiv = document.getElementById(divId);
  if (!targetDiv) {
    return;
  }

  const elements = targetDiv.getElementsByClassName(ERROR_CLASSNAME_INPUT); 
  elements && elements.length && Array.from(elements).forEach((e) => {
    e.classList.remove(ERROR_CLASSNAME_INPUT);
  });
};

export const applyErrorStyle = (errors) => {
  if (!(errors && errors.length)) {
    return;
  }

  const validationError = errors.find((e) => e.extensions && e.extensions.category === 'validation');
  if (!validationError) {
    return;
  }

  const { validation } = validationError.extensions;
  const keys = Object.keys(validation);
  if (!keys.length) {
    return;
  }

  keys.forEach((k) => {
    const target = document.getElementById(k);

    if (!target) {
      return;
    }

    const radioItems = target.getElementsByClassName('radioItem');

    if (target.nodeName === 'INPUT') {
      target.classList.add(ERROR_CLASSNAME_INPUT);
    } else if (radioItems && radioItems.length) {
      Array.from(radioItems).forEach((e) => {
        e.classList.add(ERROR_CLASSNAME_INPUT);
      });
    } else {
      const elements = target.querySelectorAll('input'); 
      elements && elements.forEach((e) => {
        e.classList.add(ERROR_CLASSNAME_INPUT);
      });
    }
  });
};
